import { mallApi, mallEntranceApi } from '../request'
import { apiPath } from '../api'

export const recommend = {
  getRecommendFeed: data => mallApi.post(apiPath.getRecommendFeed, data),
  hotSaleRankInfo: data => mallEntranceApi.post(apiPath.hotSaleRankInfo, data),
  getGoodsInfoStream: data =>
    mallEntranceApi.post(apiPath.getGoodsInfoStream, data),
  goodsRank: data => mallEntranceApi.post(apiPath.goodsRank, data)
}
